import { INITIAL_VALUES } from '@/infra/data'

export const initialForm = {
  Company: { ...INITIAL_VALUES },
  TradeName: { ...INITIAL_VALUES },
  Title: { ...INITIAL_VALUES },
  FirstName: { ...INITIAL_VALUES },
  Surname: { ...INITIAL_VALUES },
  Address: { ...INITIAL_VALUES },
  Postcode: { ...INITIAL_VALUES },
  Town: { ...INITIAL_VALUES },
  CountryId: { ...INITIAL_VALUES },
  StateId: { ...INITIAL_VALUES },
  Telephone: { ...INITIAL_VALUES },
  Mobile: { ...INITIAL_VALUES },
  Email: { ...INITIAL_VALUES },
  Text: { ...INITIAL_VALUES },
  agb_accepted: { ...INITIAL_VALUES },
  c_reason: { ...INITIAL_VALUES }
}

export const requiredFields = [
  'Company',
  'FirstName',
  'Surname',
  'Address',
  'Postcode',
  'Town',
  'CountryId',
  'Telephone',
  'Email',
  'Text',
  'agb_accepted',
  'c_reason'
]
